import { shallowRef, type ShallowRef } from "vue";

import type { ApiError } from "@/src/api/http";

/**
 * The most recent failed API call.
 *
 * A few concerns are genuinely global and cannot live next to one request: routing to the offline
 * page when the network drops, reacting to a graph lock taken by someone else, surfacing the trace
 * id of an unexpected 500. Those observers read this.
 *
 * It sits here rather than in the store so that `src/api` stays free of Vue and Vuex, and it is
 * written from both paths that can fail: `trackPending` for store-driven writes, and the query
 * cache for reads.
 */
const lastError: ShallowRef<ApiError | null> = shallowRef(null);

export function useLastApiError(): ShallowRef<ApiError | null> {
    return lastError;
}

export function setLastApiError(error: ApiError | null): void {
    lastError.value = error;
}

export function clearLastApiError(): void {
    lastError.value = null;
}
